<template>
 <el-dialog
      :title="id ? '编辑' : '添加'"
      :visible.sync="isVisiable"
      width="40%"
      @close="doCancel"
    >
      <el-form
        :model="dateForm"
        label-width="120px"
        class="add-role-form"
        :rules="dataRule"
        ref="formName"
      >
        <el-form-item label="模板类型：" prop="templateType">
            <el-select
                v-model="dateForm.templateType"
                placeholder="请选择"
                size="small"
                clearable
            >
                <el-option
                key="1"
                value="1"
                label="通用模板"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-row>
            <el-col :span="12">
                <el-form-item label="模板标题：" prop="remindingTitle">
                    <el-input
                        v-model="dateForm.remindingTitle"
                        size="small"
                        placeholder="请输入中文"
                    ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="日文标题：" prop="remindingTitleJa">
                    <el-input
                        v-model="dateForm.remindingTitleJa"
                        size="small"
                        placeholder="请输入日文"
                    ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        
        <el-form-item label="模板内容：" prop="remindingContentJa">
            <el-input
                v-model="dateForm.remindingContentJa"
                type="textarea"
                placeholder="请输入日文"
                :autosize="{ minRows: 4}"
            ></el-input>
        </el-form-item>
        
        <el-form-item label="跳转链接：">
            <el-input
                v-model="dateForm.url"
                size="small"
                placeholder="填入与消息内容中存在且相同的网址链接，可让对应链接实现点击跳转，多个链接用“,”隔开。"
            ></el-input>
        </el-form-item>

        <el-form-item label="模板说明：">
            <el-input
                v-model="dateForm.remindingNotes"
                type="textarea"
                placeholder="请输入"
                :maxlength="500"
                :autosize="{ minRows: 4}"
            ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="doCancel">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="doConfirm">保 存</el-button>
      </span>
    </el-dialog>
</template>
<script>
const dateForm = {
    id: '',
    templateType: "", // 模板类型
    remindingTitle: "", // 中文标题
    remindingTitleJa: '', // 日文标题
    remindingContentJa: '', // 模板内容日文
    url: '',// 跳转链接
    remindingNotes: ''// 模板说明
}
export default {
  name: "EditTemp",
  props: {
      isVisiable: {
          type: Boolean,
          default: false
      },
      id: {
          type: String,
          default: ''
      }
  },
  data () {
    return {
        dateForm: this._.cloneDeep(dateForm),
        dataRule: {
            templateType: [
                { required: true, message: "请选择模板类型", trigger: "change" },
            ],
            remindingTitle: [
                { required: true, message: "请输入至少1个字符，最多100个字符！", trigger: "blur" },
            ],
            remindingTitleJa: [
                { required: true, message: "请输入至少1个字符，最多100个字符！", trigger: "blur" },
            ],
            remindingContentJa: [
                { required: true, message: "必须输入模板内容,请输入日文！", trigger: "blur" },
            ],
        },
    };
  },
  watch: {
      id(val) {
          if(val) {
              this.dateForm.id = val
              this.getDetail()
          } else {
              this.dateForm = this._.cloneDeep(dateForm)
          }
      }
  },
    methods: {
        getDetail () {
            this.$http.get(`/template/message/${this.id}`, {}).then(res => {
                let info = res.data.data
                Object.keys(this.dateForm).forEach(key => {
                    this.dateForm[key] = info[key]
                })
            })
        },
        doConfirm() {
            const self = this;
            this.$refs.formName.validate(async function (valid) {
                if (valid) {
                    const { data: res } = await self.$http.post(
                        "/template/message/save",
                        self.dateForm
                    );
                    if (res.code == 200) {
                        self.$message({
                            type: "success",
                            message: res.message,
                        });
                        self.$emit('confirm')
                    } else {
                        self.$message.error(res.message);
                    }
                }
            });
        },
        doCancel() {
            this.$emit('update:isVisiable', false)
        },
        doReset() {

        }
    }
}
</script>
<style lang="scss" scoped>
</style>